import ActiveRecord from './active_record/base'
import {t} from '@eitje/bridge'

class ExtEnvironment extends ActiveRecord {
	static defaultJoins = ['environments', 'integrationExtRevenueGroups', 'integrationBaseConnections']
	static tableName = 'integrationExtEnvironments'

	isPos() {
		return this.integrationBaseConnection?.isPos()
	}

	renumerationTypeTranslation() {
		const {renumeration_period} = this
		if (renumeration_period == 'month') return t('common.monthly')
		if (renumeration_period == 'week') return t('common.weekly')
		return t('common.4_weekly')
	}
}

export default ExtEnvironment
